export class Controller {

    /** @ngInject */
    constructor(
        $state,
        AddNewSharedPasswordModal,
        ImportSharedPasswordsModal,
        AddNewSharedAuthenticatorModal,
        ImportSharedAuthenticatorsModal,
        ShareAnAdditionalEmailAccount
    ) {
        this.$state = $state;
        this.AddNewSharedPasswordModal = AddNewSharedPasswordModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.AddNewSharedAuthenticatorModal = AddNewSharedAuthenticatorModal;
        this.ShareAnAdditionalEmailAccount = ShareAnAdditionalEmailAccount;
    }

    $onInit() {
		//this.labels$.get().then((labels) => this.labels=labels);
    }
    
    importFromCSv() {
		this.$state.go('company.sharing-center.import-csv');
	}

    showAuthenticatorAddModal() {
      //  this.publicServicesWithSsoAnd2FA$.get()
        //    .then(items => this.AddNewSharedAuthenticatorModal(items))
         //   .then(() => this.$state.reload(this.$state.current))
         this.$state.go('company.sharing-center.add-shared-authenticator');
    }

    showAuthenticatorImportModal() {
        this.ImportSharedAuthenticatorsModal().then(() => this.$state.reload(this.$state.current));
    }

    showPasswordManagerAddModal() {
       // this.publicServicesWithSso$.get()
          //  .then(items => this.AddNewSharedPasswordModal(items))
          //  .then(() => this.$state.reload(this.$state.current))
          this.$state.go('company.sharing-center.add-shared-password');
    }

    showPasswordManagerImportModal() {
        this.ImportSharedPasswordsModal().then(() => this.$state.reload(this.$state.current));
    }
    showShareAnAdditionalEmailAccountModal() {
        this.ShareAnAdditionalEmailAccount();
    }

	/*showSettingsModal() {
        return this.SharingSettingsModal().then(() => this.reload());
    }*/
    stateCheckSharedNotes() {
        return this.$state.is('company.sharing-center.shared-notes');
    }
    stateCheckSharedPasswords() {
        return this.$state.is('company.sharing-center.shared-passwords');
    }
    stateCheckSharedAuthenticator() {
        return this.$state.is('company.sharing-center.shared-authenticators');
    }
    stateCheckCompanyAccount() {
        return this.$state.is('company.sharing-center.shared-accounts');
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-center.controller.js